var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"mb-4 ml-5"},[_vm._v(_vm._s(_vm.$t('text.important_dates')))]),_c('v-timeline',{staticClass:"pt-2",attrs:{"dense":""}},_vm._l((_vm.sortedList),function(item){return _c('TimeLineItem',{key:item.text,attrs:{"text":item.text,"date":item.date,"passedColor":item.passedColor}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }